import jwtDecode from "jwt-decode";

const useImagesFromSubscriberSegments = () => {
  const token = localStorage.getItem("token") || "";
  const decodedToken: {} = jwtDecode(token);
  const segmentsString = decodedToken["http://secure.ipdanalytics.com/claims/subscriberSegment"];
  const segmentsArray = segmentsString.split("|");

  if (segmentsArray.includes("Main Street") || segmentsArray.includes("Wall Street")) {
    return {
      page1: `${process.env.PUBLIC_URL}/images/LearnMorePopups/PayerAndProviderInsights/MainStreetAndWallStreet/page1.png`,
      page2: `${process.env.PUBLIC_URL}/images/LearnMorePopups/PayerAndProviderInsights/MainStreetAndWallStreet/page2.png`,
    };
  }

  return {
    page1: `${process.env.PUBLIC_URL}/images/LearnMorePopups/PayerAndProviderInsights/Manufacturer/page1.png`,
    page2: `${process.env.PUBLIC_URL}/images/LearnMorePopups/PayerAndProviderInsights/Manufacturer/page2.png`,
  };
};

export default useImagesFromSubscriberSegments;
